export const ARTIFACTS_EXPIRED_ERROR_MESSAGE = 'Test report artifacts not found';
